import type { QueryKey, UseQueryOptions } from '@tanstack/react-query'
import { API_CONFIG } from 'config/api'

export type BackendQueryOptions<TData, TQueryFnData = TData, TError = Error> = Omit<
  UseQueryOptions<TQueryFnData, TError, TData, QueryKey>,
  'queryKey' | 'queryFn'
> & { skip?: boolean; queryKey?: QueryKey }

export const toApiError = async (response: Response) => {
  const data = await response.json().catch(() => undefined)
  const error = new Error((data as any)?.message || response.statusText || 'Request failed') as Error & {
    status?: number
    data?: any
  }

  error.status = response.status
  error.data = data
  return error
}

const withJsonHeaders = (init?: RequestInit): RequestInit => {
  const headers = new Headers(init?.headers)
  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json')
  }

  return { ...init, headers }
}

export const fetchBackendJson = async <T>(path: string, init: RequestInit = {}): Promise<T> => {
  const response = await fetch(`${API_CONFIG.baseUrl}${path}`, withJsonHeaders(init))

  if (!response.ok) {
    throw await toApiError(response)
  }

  return (await response.json()) as T
}
